import { render, staticRenderFns } from "./ShippingItems.vue?vue&type=template&id=14be5e97&"
import script from "./ShippingItems.vue?vue&type=script&lang=js&"
export * from "./ShippingItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports